import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  EventEmitter,
  Input,
  NgZone,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { rxNgZoneRun } from 'src/helpers/rxNgZoneRun';
import { AccordionContentComponent } from './accordion-content/accordion-content.component';
import { AccordionHeaderComponent } from './accordion-header/accordion-header.component';

@Component({
  selector: 'app-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccordionComponent
  implements AfterContentInit, OnDestroy, OnChanges, OnInit
{
  @ContentChild(AccordionHeaderComponent)
  headerComponent?: AccordionHeaderComponent;
  @ContentChild(AccordionContentComponent)
  contentComponent?: AccordionContentComponent;

  collapsed$ = new BehaviorSubject<boolean>(false);
  @Input() set collapsed(value: boolean) {
    this.collapsed$.next(value);
  }
  get collapsed() {
    return this.collapsed$.value;
  }
  @Output() accordionToggled = new EventEmitter<boolean>();
  toggleClickSubscription?: Subscription;

  constructor(private ngZone: NgZone) {}

  ngOnInit(): void {
    this.setHeaderCollapsedState();
    this.setContentCollapsedState();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.collapsed) {
      this.setHeaderCollapsedState();
      this.setContentCollapsedState();
    }
  }

  ngAfterContentInit(): void {
    this.subscribeToggleClick();
    this.setHeaderCollapsedState();
    this.setContentCollapsedState(true);
  }

  ngOnDestroy(): void {
    this.unsubscribe();
  }

  subscribeToggleClick(): void {
    if (this.headerComponent && this.headerComponent.toggleClickEmitter) {
      this.toggleClickSubscription = this.headerComponent.toggleClickEmitter
        .pipe(rxNgZoneRun(this.ngZone))
        .subscribe(() => {
          this.toggle();
        });
    }
  }

  toggle(): void {
    this.collapsed = !this.collapsed;
    this.setContentCollapsedState();
    this.setHeaderCollapsedState();
    this.accordionToggled.emit(this.collapsed);
  }

  setHeaderCollapsedState(): void {
    if (this.headerComponent) {
      this.headerComponent.setCollapsedState(this.collapsed);
    }
  }

  setContentCollapsedState(init = false): void {
    this.ngZone.run(() => {
      if (this.contentComponent) {
        if (this.collapsed) {
          this.contentComponent.collapse(init);
        } else {
          this.contentComponent.unCollapse(init);
        }
      }
    });
  }

  unsubscribe(): void {
    if (this.toggleClickSubscription) {
      this.toggleClickSubscription.unsubscribe();
    }
  }
}
